/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { CategoryArr } from "../../common/svg/AllSvg";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Error from "../../common/form/Error";

const Category = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [select, setSelect] = useState<any>(0);
    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState<any>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const loaderData: any[] = [1, 2, 3, 4, 5]
    const { t } = useTranslation('common');
    const navigate = useNavigate();
    const params = useParams();

    const getData = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.jobCategory}`);

            if (res && res.status === 200) {
                setData(res?.data?.results)
                setLoading(false)
            }
        } catch (error) {
            setIsError(true)
            setLoading(false)
            console.error("error while fetching job category", error);
        }
    }

    useEffect(() => {
        !!lang && getData();
    }, [lang])

    return (
        <div className="flex flex-col gap-[30px] msm:gap-[45px] container pt-[30px] lg:pt-[75px]">
            {/* pt-0 md:pt-[-15px] xlx:pt-[-40px] */}
            {/* pb-[30px] lg:pb-[50px] xlx:pb-[72px] */}
            <div className="flex flex-col gap-[4px]">
                <h1 className="font-bold text-[#AE8639]">{t("recruitment.home.browse_category.title")}</h1>
                <h3 className="text-blackDark dark:text-textBlackDark font-medium">{t("recruitment.home.browse_category.title1")}</h3>
            </div>

            {loading ?
                <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 msm:grid-cols-4 xl:grid-cols-5 gap-[15px] msm:gap-[19px]">
                    {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                        <div key={index} className="rounded-[8px] h-[130px] xlx:h-[150px] p-[20px] xlx:px-[30px] w-full animate-pulse border border-gray-200 dark:border-gray-700 shadow flex flex-col justify-between">
                            <div className="flex flex-col gap-[10px] items-start">
                                <div className="max-w-[165px] w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                <div className="max-w-[90px] w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                            </div>

                            <div className="max-w-[100px] w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                        </div>
                    ))}
                </div>
                :
                <>
                    {isError ? <Error /> : <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 msm:grid-cols-4 xl:grid-cols-5 gap-[15px] msm:gap-[19px]">
                        {Array.isArray(data) && data?.map((item: any, index: number) => (
                            <button key={index} className={`${select === index ? "bg-primary" : "bg-[#F5F5F5]"} rounded-[8px] h-[130px] xlx:h-[150px] p-[20px] xlx:px-[30px] w-full flex flex-col justify-between`} onMouseEnter={() => setSelect(index)} onClick={() => !!params?.lang ? navigate(`/${params?.lang}/jobs/${item?.id}`) : navigate(`/jobs/${item?.id}`)} onFocus={() => setSelect(index)}>
                                <div className="flex flex-col gap-[6px] items-start">
                                    <h4 className={`${select === index ? "text-white" : "text-blackDull"} text-[1.25rem] font-bold text-left leading-snug`}>{item?.title}</h4>
                                    <h6 className={`${select === index ? "text-white" : "text-blackDark"} font-normal opacity-[0.6]`}>{item?.total_no_of_jobs} {t("recruitment.home.browse_category.job_available")}</h6>
                                </div>

                                <div className="flex items-center gap-[15px]">
                                    <h6 className={`${select === index ? "text-white" : "text-primary"} font-semibold`}>{t("recruitment.home.browse_category.exp_job")}</h6>

                                    <div className="min-w-[7px]">
                                        <CategoryArr className={`${select === index ? "fill-white" : "fill-primary"}`} />
                                    </div>
                                </div>
                            </button>
                        ))}
                    </div>}
                </>
            }
        </div>
    );
};

export default Category;